export const formatOptions = (listArray) => {
    return listArray.map((ele) => {
      return { value: ele, label: ele };
    });
  };

  export const customFormatOptions = (listArray,value,label) => {
    return listArray.map((ele) => {
      return { value: ele[`${value}`], label: ele[`${label}`] };
    });
  };